import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20gradient%20abstract%20background%20with%20flowing%20organic%20shapes%20in%20amber%20and%20terracotta%20tones%2C%20soft%20dreamy%20texture%2C%20minimalist%20artistic%20style%2C%20encouraging%20and%20uplifting%20atmosphere%2C%20warm%20light%20diffusion%2C%20editorial%20art%20photography&width=1600&height=600&seq=cta-bg-home&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/80 via-primary-800/70 to-primary-900/80"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 md:px-10 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
          准备好迎接你的下一个「第一次」了吗？
        </h2>
        <p className="text-background-50/80 mb-8 max-w-xl mx-auto leading-relaxed">
          每一次全新的尝试，都是你生命中不可复制的成长印记。从这里开始，让每一步都走得更加从容。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/career"
            className="px-8 py-3.5 bg-background-50 hover:bg-background-100 text-primary-700 font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            浏览全部指南
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-transparent hover:bg-background-50/10 text-background-50 font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-50/40"
          >
            了解我们的故事
          </Link>
        </div>
      </div>
    </section>
  );
}